<mat-toolbar color="primary" class="header">
    <div class="left-section">
        <a [href]="appUrl" rel="noopener noreferrer">
            <img [src]="logo" alt="App Logo" class="app-logo" [style]="logoStyle" />
        </a>
        @if (showPoweredBy) {
            <span class="powered-by">Powered by Perse&trade;</span>
        }
    </div>
    <div class="center-section d-none d-sm-block">
        <!-- @if (isUserLoggedIn$ | async) { -->
            <span class="app-title">{{ name }}</span>
        <!-- } -->
    </div>
    <div class="right-section">
        @if (isUserLoggedIn$ | async) {
            <span class="user-name d-none d-lg-block">{{ userName }}</span>

            <!-- User Account Button -->
            <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
                <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #userMenu="matMenu">
                <div class="menu-header" mat-menu-item disabled>
                    <mat-icon>person</mat-icon>
                    <span>{{ userName }}</span>
                </div>
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="/profile">
                    <mat-icon>manage_accounts</mat-icon>
                    <span>Profile</span>
                </button>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        }
    </div>
</mat-toolbar>